import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ITraveller } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { Yii } from 'libraries/interfaces/Yii';
import { TravellerDataTranslationService } from 'libraries/service/traveller-data-translation/traveller-data-translation.service';
import { ILabels } from 'libraries/interfaces/ILabels';
import { PersonRole } from 'libraries/service/resources/booking/interfaces/get-bookings.enum';

@Component({
    selector: 'booking-contacts-contact',
    template: `
        <div class="contact">
            <div *ngIf="showTravellerNames" class="traveller">
                <span>{{ travellerName }}</span>
                <strong>{{ role }}</strong>
            </div>

            <div class="coordinates">
                <div class="emails column">
                    <div class="email" *ngFor="let email of traveller.email">{{ email.text }}</div>
                    <div *ngIf="!traveller.email" class="noInformation">{{ labels.noEmail }}</div>
                </div>

                <div class="telephones column">
                    <telephone *ngFor="let telephone of traveller.telephone" [telephone]="telephone"></telephone>
                    <div *ngIf="!traveller.telephone" class="noInformation">{{ labels.noTelephone }}</div>
                </div>

                <div class="addresses column">
                    <address-component *ngFor="let address of traveller.address" [property]="address"></address-component>
                    <div *ngIf="!traveller.address" class="noInformation">{{ labels.noAddress }}</div>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .coordinates {
            display: flex;
            flex: 1;
            padding: .75rem .75rem 0 .75rem;
        }

        .traveller {
            display: flex;
            flex-direction: column;
            width: 225px;
            padding: .75rem;
            background-color: #fff;
            border-right: 1px solid rgba(189, 195, 199, 0.2);
        }

        .contact {
            display: flex;
        }

        .column {
            display: flex;
            flex-direction: column;
            flex: 1;
        }

        .email:not(:last-child), telephone:not(:last-child), address:not(:last-child) {
            margin-bottom: 4px;
        }

        .noInformation {
            color: #6E6E6E;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingContactsContactComponent implements OnChanges {
    @Input()
    public traveller: ITraveller;

    @Input()
    public isCustomer: boolean = false;

    @Input()
    public showTravellerNames: boolean = true;

    @Input()
    public personRole: PersonRole;

    public role: string;
    public travellerName: string;
    public labels: ILabels = {
        noEmail: Yii.t('wui-shared-js', 'Aucun email'),
        noTelephone: Yii.t('wui-shared-js', 'Aucun téléphone'),
        noAddress: Yii.t('wui-shared-js', 'Aucune adresse'),
    };

    constructor(
        private readonly travellerDataTranslationService: TravellerDataTranslationService
    ) {
    }

    public ngOnChanges(): void {
        if (this.traveller) {
            this.travellerName = this.travellerDataTranslationService.getTravellerIdentity(this.traveller);
            this.role = this.travellerDataTranslationService.translateRole(this.personRole);
        }
    }
}
